import _toConsumableArray from "/drone/src/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "/drone/src/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import traverse from 'traverse';
import { replaceThemeToken } from '../../system/util/replaceThemeToken';
import { consoleWarn } from '../../system/util/consoleWarn';
var autoSpacingProperties = {
  padding: true,
  paddingLeft: true,
  paddingRight: true,
  paddingTop: true,
  paddingBottom: true,
  margin: true,
  marginLeft: true,
  marginRight: true,
  marginTop: true,
  marginBottom: true,
  top: true,
  bottom: true,
  left: true,
  right: true,
  height: true,
  minHeight: true,
  maxHeight: true,
  width: true,
  minWidth: true,
  maxWidth: true,
  safeMargin: true
};

var prependKeys = function prependKeys(dst, src) {
  var tmp = _objectSpread({}, dst);

  Object.keys(dst).forEach(function (key) {
    return delete dst[key];
  });
  Object.keys(src).forEach(function (key) {
    dst[key] = src[key];
  });
  Object.keys(tmp).forEach(function (key) {
    dst[key] = tmp[key];
  });
};

export var transformTheme = function transformTheme(theme, chunk, prefix) {
  var spacing = theme.spacing,
      pixelToRem = theme.typography.pixelToRem;
  traverse(chunk).forEach(function transformThemeObject(value) {
    var _this = this;

    this.before(function () {
      if (_this.node && _this.node.$typography) {
        var typographyKey = _this.node.$typography;
        delete _this.node.$typography;

        if (typographyKey in theme.typography || typographyKey === '$inherit') {
          if (Array.isArray(_this.keys)) {
            var source = typographyKey in theme.typography ? theme.typography[typographyKey] : {
              fontFamily: 'inherit',
              fontSize: 'inherit',
              fontWeight: 'inherit',
              letterSpacing: 'inherit',
              lineHeight: 'inherit',
              color: 'inherit'
            };
            prependKeys(_this.node, source);
            _this.keys = [].concat(_toConsumableArray(Object.keys(source)), _toConsumableArray(_this.keys));
          }
        } else {
          consoleWarn("Unknown typography alias \"".concat(typographyKey, "\" was ignored at ").concat(prefix ? "".concat(prefix, ".") : '').concat(_this.path.join('.')));
        }
      }
    });

    var _replaceThemeToken = replaceThemeToken(value, theme, prefix, this.path),
        newValue = _replaceThemeToken.value,
        updated = _replaceThemeToken.updated;

    if (this.key === 'fontSize' || this.key === 'lineHeight') {
      newValue = pixelToRem(newValue);
      updated = true;
    }

    if (this.key === 'fontFamily' && newValue !== 'inherit' && newValue !== 'initial') {
      newValue = "".concat(newValue, ", sans-serif");
      updated = true;
    }

    if (this.key in autoSpacingProperties) {
      newValue = spacing(newValue);
      updated = true;
    }

    if (updated) {
      this.update(newValue);
    }
  });
  return chunk;
};